import { render, staticRenderFns } from "./Tesoreria.vue?vue&type=template&id=519cd424&scoped=true"
import script from "./Tesoreria.vue?vue&type=script&lang=js"
export * from "./Tesoreria.vue?vue&type=script&lang=js"
import style0 from "./Tesoreria.vue?vue&type=style&index=0&id=519cd424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519cd424",
  null
  
)

export default component.exports